import React from "react";
import { useGetScore } from "hooks/queries/useGetScore";

const ScoreDisplay = ({ onClose }) => {
  const { score } = useGetScore();

  const getScoreText = (score:any) => {
    score = parseFloat(score);

    if (score < 2) {
      return "Poor";
    } else if (score >= 2 && score < 3) {
      return "Average";
    } else if (score >= 3 && score < 4) {
      return "Good";
    } else if (score >= 4) {
      return "Excellent";
    }
  };

  const scoreText = getScoreText(score);

  return (
    <div className="results-summary-container">
      <div className="confetti">
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
      </div>
      <div className="results-summary-container__result">
        <div className="heading-tertiary">Your Result</div>
        <div className="result-box">
          <div className="heading-primary">{score}</div>
          <p className="result">of 4</p>
        </div>
        <div className="result-text-box">
          <div className="heading-secondary">{scoreText}</div>
          <p className="paragraph">Here is your performance rating after Manager's Assessment</p>
        </div>
        <div className="summary__cta">
          <button className="btn btn__continue" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScoreDisplay;
